import ServiceJobComponentModel from "./ServiceJobComponentModel";

export default class ServiceJobGroupModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id ?? 0;
			this.date = data.date ?? new Date(1970,0,1);
			this.name = data.name ?? '';
			this.description = data.description ?? null;
		
			if (data?.components?.length) {
				this.components = data.components.map((_: any) => new ServiceJobComponentModel(_));
			}
		}
	}

	id = 0;	
	date = new Date(1970,0,1);
	name = '';
	description: string | null = null;
	components: Array<ServiceJobComponentModel> | null = null;
}